//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueSlider from "vue-slider-component";
import {directive as vueOnClickAway} from 'vue-clickaway';
import _ from 'lodash';

export default {
    props : {
        filter: {
            required : true
        },
        openable : {
            type : Boolean,
            default : true
        },
        filter_button : {
            type : Boolean,
            default : true
        },
        filters_opened : {},
        is_showing : {
            type : Boolean,
            default : true
        },
        pre_selected_values : {
            default : function () {
                return {};
            }
        }
    },
    data : function () {
        return {
            selected_single_value : 0,
            filter_open : false,
            max_filter_label_size : 30,
            selected_values : this.pre_selected_values,
            expanded_values : {},
            icons : rest_options.options.icons,
            translations : rest_options.options.translations,
            range_value : [
                this.filter.min,
                this.filter.max
            ]
        };
    },
    updated : function () {
        this.range_undefined_reset();
    },
    computed : {
        filter_label_text : function () {
            if (this.filter_type() == 'dropdown') {
                var dropdown_values = this.filter_dropdown_values();
                var dropdown_value_count = dropdown_values.length;

                if(dropdown_value_count === 1) {
                    var dropdown_original_value = dropdown_values[0].name;

                    if (dropdown_original_value.length < this.max_filter_label_size) {
                        return dropdown_original_value;
                    }

                    var dropdown_value_words = dropdown_original_value.split(" ");
                    var dropdown_value = "";

                    for (var w in dropdown_value_words) {
                        var word = dropdown_value_words[w];

                        if (!dropdown_value.length || (dropdown_value + " " + word).length < this.max_filter_label_size) {
                            dropdown_value = dropdown_value + " " + word;
                        } else {
                            break;
                        }
                    }

                    return dropdown_value + "...";
                }
            } else if (this.filter_type() == 'range') {
                return this.range_value[0] + ' – ' + this.range_value[1];
            }

            // At some point these translations broke or maybe never worked before
            // since there's nothing in Wordpress, Polylang or po/mo for it?
            // - https://hiondigital.atlassian.net/browse/CSD-1892
            let language = document.documentElement.lang;
            if (language === 'en-GB') {
              if (this.filter.label === 'Artikkelin tyyppi') { return 'Article type' }
              if (this.filter.label === 'Aihealueet') { return 'Topics' }
              if (this.filter.label === 'Hallinnonalat') { return 'Administrative branches' }
              if (this.filter.label === 'Julkaisulajit') { return 'Publication types' }

            } else if (language === 'sv-SE') {
              if (this.filter.label === 'Artikkelin tyyppi') { return 'Artikeltyp' }
              if (this.filter.label === 'Aihealueet') { return 'Ämnen' }
              if (this.filter.label === 'Hallinnonalat') { return 'Administrativa grenar' }
              if (this.filter.label === 'Julkaisulajit') { return 'Publikationstyper' }

            } else {
              // Finnish is default
              return this.filter.label;
            }

        },
        filter_wrapper_classes : function () {
            var classes = [];

            classes.push('filter');

            if(this.openable) {
                classes.push('filter--openable');
            }

            if(this.filter_open) {
                classes.push('filter--open');
            }

            if(this.filter_type() == 'dropdown') {
                if(this.filter_dropdown_values().length) {
                    classes.push('filter--has-values');
                }
            }

            classes.push('filter--' + this.filter_type());

            return classes;
        },
        filter_content_classes : function () {
            var classes = [];

            classes.push("filter__content");
            classes.push(this.filter_type());

            return classes;
        }
    },
    methods : {
        is_visible : function (item, id) {
            /*
            This function controls visibility of submenu items together with expanded_check().
            To enable visibility control, remove forced return & enable commented part of code
            */
            return false;
            /*if (!item.parent) {
                return true;
            } else if(item.parent === 0) {
                return true;
            } else if(this.expanded(item.parent)){
                return true;
            } else {
                return false;
            }*/
        },
        expanded_check : function (item) {
            /*
            This function controls visibility of submenu items together with is_visible().
            To enable visibility control, remove forced return & enable commented part of code
            */
            return true
            /*return this.expanded_values[item.parent] || item.nesting_level === 0 || !item.parent;*/
        },
        expanded : function (parent) {
            if(this.expanded_values.length > 0 && this.expanded_values.hasOwnProperty(parent) > -1) {
                return true;
            } else {
                return false;
            }
        },
        expand_item : function (item) {
            if(this.expanded_values[item.id] === true) {
                this.$set(this.expanded_values, item.id, false)
            } else {
                this.$set(this.expanded_values, item.id, true)
            }
        },
        range_undefined_reset : function () {
            if(this.filter_type() != 'range') {
                return;
            }

            if(this.range_value[0] == undefined) {
                this.range_value[0] = this.filter.min;
            }

            if(this.range_value[1] == undefined) {
                this.range_value[1] = this.filter.max;
            }
        },
        is_filter_open : function () {
            if(!this.openable) {
                return true;
            }

            return this.filter_open;
        },
        run_filtering : function () {
            this.$emit('run-search');
            this.$emit('filter-button-pressed');
            this.filter_open = false;
        },
        filter_dropdown_values : function () {
            if(this.filter_type() != 'dropdown') {
                return [];
            }

            var dropdown_values = [];
            for(var f in this.selected_values) {
                if(this.selected_values[f] && this.filter.items[f]) {
                    dropdown_values.push(this.filter.items[f]);
                }
            }

            return dropdown_values;
        },
        update_filter_selection : function (item = null) {
            this.expand_item(item)
            this.toggle_filters(item)
            this.$emit('update-selection', this.filter.type, this.filter.name, this.get_values(), this.filter_button);
        },
        toggle_filters : function (item) {
            if(item.nesting_level > 0 && item.parent && this.selected_values[item.parent] === true) {
                this.selected_values[item.parent] = false;
            }
            if(item && item.children && this.selected_values[item.id] === true) {
                for(var i in item.children) {
                    this.selected_values[item.children[i]] = true
                }
            } else if (item && item.children && this.selected_values[item.id] === false) {
                for(var i in item.children) {
                    this.selected_values[item.children[i]] = false
                }
            }
        },
        filter_type : function () {
            if(this.filter.type == 'post_type' || this.filter.type == 'taxonomy') {
                return 'dropdown';
            }

            return this.filter.type;
        },
        filter_away_close : function () {
            this.filter_open = false;
        },
        toggle_filter_open : function () {
            this.filter_open = !this.filter_open;
            this.$emit("filter-opened", this);
        },
        remove_selection : function () {
            if(this.filter_type() == 'dropdown') {
                this.selected_values = {};
            } else if (this.filter_type() == 'range') {
                this.range_value = [this.filter.min, this.filter.max];
            } else if (this.filter_type() == 'radio') {
                this.selected_single_value = this.filter.values[0].value;
            }
        },
        get_range_values : function () {
            this.range_undefined_reset();

            var values = {
                from : this.range_value[0],
                to : this.range_value[1]
            };

            return values;
        },
        get_values : function () {
            if(this.filter_type() == 'range') {
                return this.get_range_values();
            } else if(this.filter_type() == 'dropdown') {
                var values = {};

                for(var item in this.selected_values) {
                    var value = this.selected_values[item];

                    if(value) {
                        values[item] = value;
                    }
                }

                return values;
            } else if (this.filter_type() == 'radio') {
                return this.selected_single_value;
            }
        }
    },
    directives : {
        onClickaway : vueOnClickAway,
    },
    components : {
        vueSlider
    }
}



// WEBPACK FOOTER //
// ./js/vue/search/search-filter.vue